// LD flag variables
export const fdt1433 = 'fdt-1433-rippling-payroll-integration';
export const fdt1523 = 'fdt-1523-rippling-payroll-schedule-and-position-syncing';
export const fdtRipplingWageSyncOptOut = 'fdt-1605-rippling-wage-sync';

// Key variables
export const RIPPLING_INITIAL_EXPERIENCE = 'RIPPLING_INITIAL_EXPERIENCE';
export const RIPPLING_POSITIONS_FIRST_SAVE = 'RIPPLING_POSITIONS_FIRST_SAVE';
export const RIPPLING_REQUEST_TYPES_FIRST_SAVE = 'RIPPLING_REQUEST_TYPES_FIRST_SAVE';
export const RIPPLING_SCHEDULES_FIRST_SAVE = 'RIPPLING_SCHEDULES_FIRST_SAVE';
export const RIPPLING_USERS_FIRST_SAVE = 'RIPPLING_USERS_FIRST_SAVE';
export const LOCAL_STORAGE_JOB_DIMENSION_KEY = 'integrations_rippling_dismissed_add_job_dimension_banner';
export const LOCAL_STORAGE_POSITION_SYNCING_BANNER_KEY = 'integrations_rippling_dismissed_position_syncing_banner';
export const LOCAL_STORAGE_EXPORT_WAGES_KEY = 'integrations_rippling_dismissed_export_wages_banner';
export const LOCAL_STORAGE_PENDING_SYNC_WAGES = 'RIPPLING_PENDING_SYNC_WAGES';
export enum RIPPLING_ERROR_CODE {
  RIPPLING_USER_NEW = 'RIPPLING_USER_NEW',
  RIPPLING_USER_DELETE = 'RIPPLING_USER_DELETE',
  RIPPLING_SYNCED_FIELD = 'RIPPLING_SYNCED_FIELD',
}
export const RIPPLING = 'rippling';

//Message variables
export const DEFAULT_SYNC_ERROR_MESSAGE = 'Unable to sync Rippling users. Please try again.';
export const DEFAULT_PAYROLL_ERROR_MESSAGE = 'Unable to start payroll run, Please try again.';
export const RIPPLING_AUTOMATCH_FAILURE_MESSAGE = 'Unable to auto-match users in Rippling. Please try again.';
export const RIPPLING_CONNECTION_SUCCESS_BODY_MESSAGE = 'Take a moment to complete and save your configuration.';
export const RIPPLING_CONNECTION_SUCCESS_TITLE_MESSAGE = 'Connected to Rippling!';
export const RIPPLING_SAVE_SUCCESS_MESSAGE = 'Your settings have been successfully saved';
export const RIPPLING_SYNC_COMPLETE_MESSAGE = 'Rippling user sync complete';
export const RIPPLING_SYNC_START_MESSAGE = 'Rippling user sync started. It may take a few minutes to complete.';
export const RIPPLING_SYNC_STATUS_ERROR_MESSAGE = 'Unable to load Rippling user sync job status.';
export const RIPPLING_SYNC_TIMEOUT_MESSAGE =
  'Rippling user sync is taking longer than expected. Please try again later.';
export const RIPPLING_SYNC_FAILURE_MESSAGE =
  "Something went wrong enabling the integration. Try again in a bit, and if that doesn't work, contact our support team.";

// -- Payroll poll message
export const RIPPLING_PAYROLL_STATUS_ERROR_MESSAGE = 'Unable to load Rippling payroll job status.';
export const RIPPLING_PAYROLL_TIMEOUT_MESSAGE =
  'Rippling payroll is taking longer than expected. Please try again later.';

// -- Position Delete message variables
export const RIPPLING_POSITION_DELETE_PAY_RUN_ERROR_CODE = 4053;
export const RIPPLING_POSITION_DELETE_ERROR_CODE = 4054;
export const RIPPLING_POSITION_DELETE_PAY_RUN_ERROR_MESSAGE = (name: string) =>
  `The position "${name}" can't be deleted because it was used in a pay run in Rippling.`;
export const RIPPLING_POSITION_DELETE_PAY_RUN_ERROR_MESSAGE_PLURAL = (names: string) =>
  `These positions can't be deleted because they were used in a pay run in Rippling: ${names}`;
export const RIPPLING_POSITION_DELETE_ERROR_MESSAGE = (name: string) =>
  `The position "${name}" can't be deleted because something went wrong in Rippling.`;
export const RIPPLING_POSITION_DELETE_ERROR_MESSAGE_PLURAL = (names: string) =>
  `These positions can't be deleted because something went wrong in Rippling: ${names}`;

// -- Position Sync message variables
export const RIPPLING_POSITION_SAVE_ERROR_MESSAGE = 'Unable to save positions. Please try again.';
export const RIPPLING_POSITION_SYNC_COMPLETE_MESSAGE = 'Rippling position sync complete';
export const RIPPLING_POSITION_SYNC_START_MESSAGE =
  'Rippling position sync started. It may take a few minutes to complete.';
export const RIPPLING_POSITION_SYNC_ERROR_MESSAGE = 'Unable to sync Rippling positions. Please try again.';
export const RIPPLING_POSITION_SYNC_STATUS_ERROR_MESSAGE = 'Unable to load position sync job status.';
export const RIPPLING_POSITION_SYNC_TIMEOUT_MESSAGE =
  'Position sync is taking longer than expected. Please try again later.';

// -- Schedule Delete message variables
export const RIPPLING_SCHEDULE_DELETE_PAY_RUN_ERROR_CODE = 4055;
export const RIPPLING_SCHEDULE_DELETE_ERROR_CODE = 4056;
export const RIPPLING_SCHEDULE_DELETE_PAY_RUN_ERROR_MESSAGE = (name: string) =>
  `The schedule "${name}" can't be deleted because it was used in a pay run in Rippling.`;
export const RIPPLING_SCHEDULE_DELETE_PAY_RUN_ERROR_MESSAGE_PLURAL = (names: string) =>
  `These schedules can't be deleted because they were used in a pay run in Rippling: ${names}`;
export const RIPPLING_SCHEDULE_DELETE_ERROR_MESSAGE = (name: string) =>
  `The schedule "${name}" can't be deleted because something went wrong in Rippling.`;
export const RIPPLING_SCHEDULE_DELETE_ERROR_MESSAGE_PLURAL = (names: string) =>
  `These schedules can't be deleted because something went wrong in Rippling: ${names}`;

// -- Schedule Sync message variables
export const RIPPLING_SCHEDULE_SYNC_COMPLETE_MESSAGE = 'Sync complete';
export const RIPPLING_SCHEDULE_SYNC_START_MESSAGE =
  'Rippling schedule sync started. It may take a few minutes to complete.';
export const RIPPLING_SCHEDULE_SYNC_ERROR_MESSAGE = 'Unable to sync Rippling schedules. Please try again.';
export const RIPPLING_SCHEDULE_SYNC_STATUS_ERROR_MESSAGE = 'Unable to load schedule sync job status.';
export const RIPPLING_SCHEDULE_SYNC_TIMEOUT_MESSAGE =
  'Schedule sync is taking longer than expected. Please try again later.';

// -- Assignment Sync message variables
export const RIPPLING_ASSIGNMENT_SYNC_COMPLETE_MESSAGE = 'Sync complete.';
export const RIPPLING_ASSIGNMENT_SYNC_ERROR_MESSAGE = 'Unable to sync assignments. Please try again.';
export const RIPPLING_ASSIGNMENT_SYNC_STATUS_ERROR_MESSAGE = 'Unable to load assignment sync job status.';
export const RIPPLING_ASSIGNMENT_SYNC_TIMEOUT_MESSAGE =
  'Assignment sync is taking longer than expected. Please try again later.';

export const USER_SYNC_JOB_FAILED_MESSAGE = 'Unable to sync users. Please try again.';
export const USER_SYNC_TIMEOUT_MESSAGE = 'User sync is taking longer than expected. Please try again later.';
export const USER_SYNC_MISSING_STATUS_MESSAGE = 'Unable to load user sync job status.';

export const PAYROLL_SYNC_JOB_FAILED_MESSAGE = 'Unable to sync payroll. Please try again.';
export const PAYROLL_SYNC_TIMEOUT_MESSAGE = 'Payroll sync is taking longer than expected. Please try again later.';
export const PAYROLL_SYNC_MISSING_STATUS_MESSAGE = 'Unable to load payroll job status.';

// Content variables
export const RIPPLING_ADD_USER_ALERT_LABEL =
  'Your workplace is using Rippling to manage users in When I Work. This action can only be done in Rippling.';
export const RIPPLING_SIGN_IN_REMINDER = 'Rippling needs you to sign in to continue using the integration.';
export const RIPPLING_SIGN_IN_CTA = 'Sign in to Rippling';

// Misc variables
export const DEFAULT_INTERVAL_MS = 5000;
export const DEFAULT_MAX_ATTEMPTS = 30;

export const IGNORE = 'ignore';
export const UNMATCH = 'unmatch';

export const RIPPLING_APP_BASE_URL = 'https://app.rippling.com';
export const RIPPLING_SYNC_TOAST_ID = 'rippling-sync-progress';
export const RIPPLING_POSITION_SYNC_TOAST_ID = 'rippling-position-sync-progress';
export const RIPPLING_SCHEDULE_SYNC_TOAST_ID = 'rippling-schedule-sync-progress';

// Configuration Tab variables
export const RIPPLING_TAB_KEY_POSITIONS = 'positions';
export const RIPPLING_TAB_KEY_EMPLOYEES = 'employees';
export const RIPPLING_TAB_KEY_TIMEOFF = 'timeoff';
export const RIPPLING_TAB_KEY_SCHEDULES = 'schedules';
export const RIPPLING_TAB_KEY_WAGES = 'wages';
